import React from "react";

export function CalendarProviderLogo({ provider, size = 16 }) {
  if (provider === "google") {
    return (
      <svg aria-hidden="true" height={size} viewBox="0 0 24 24" width={size}>
        <path d="M21.35 12.22c0-.71-.06-1.22-.2-1.76H12v3.5h5.37c-.11.87-.71 2.18-2.04 3.06l-.02.12 2.96 2.29.21.02c1.94-1.79 3.07-4.42 3.07-7.23Z" fill="#4285F4" />
        <path d="M12 21.7c2.63 0 4.84-.87 6.45-2.36l-3.07-2.37c-.82.57-1.92.98-3.38.98a5.86 5.86 0 0 1-5.52-4.05l-.11.01-3.08 2.38-.04.1A9.74 9.74 0 0 0 12 21.7Z" fill="#34A853" />
        <path d="M6.48 13.9A5.9 5.9 0 0 1 6.17 12c0-.66.12-1.3.3-1.9v-.12L3.35 7.56l-.1.05A9.72 9.72 0 0 0 2.3 12c0 1.57.37 3.05.95 4.39l3.23-2.49Z" fill="#FBBC05" />
        <path d="M12 6.05c1.83 0 3.06.79 3.76 1.45l2.75-2.68C16.82 3.25 14.63 2.3 12 2.3a9.74 9.74 0 0 0-8.75 5.31l3.22 2.5A5.88 5.88 0 0 1 12 6.05Z" fill="#EA4335" />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" height={size} viewBox="0 0 24 24" width={size}>
      <rect fill="#0F6CBD" height="18" rx="2" width="16" x="4" y="3" />
      <path d="m6.5 8 5.5 4.2L17.5 8v8H6.5V8Z" fill="#FFFFFF" opacity=".96" />
      <path d="m6.5 8 5.5 4.2L17.5 8" fill="none" stroke="#0F6CBD" strokeWidth=".8" />
      <rect fill="#185ABD" height="12" rx="1.5" width="8" x="1" y="6" />
      <text fill="#FFFFFF" fontFamily="Arial, sans-serif" fontSize="7" fontWeight="700" textAnchor="middle" x="5" y="14.4">O</text>
    </svg>
  );
}
